import config from './config'
// import VueI18n from '@/assets/lang/i18n'
import $store from '@/store/index'
const moment = require('moment')

export const SHOWTVUDEVICE = (sourceInfo) => {
  const type = sourceInfo.tangibleType || ''
  const _type = type.toLowerCase()
  const status = sourceInfo.status
  const thumbnailId = sourceInfo.tangibleId || ''
  const env = thumbnailId ? $store.state.updateThumImgTime.env[thumbnailId] : ''

  const blobUrl = $store.state.initConfig.blobUrl
  const cnBlobUrl = $store.state.initConfig.cnBlobUrl
  const header = window.location.protocol.includes('https') ? 'https://' : 'http://'
  const device = ['t', 'x', 'grid', 'grid_pack', 'grid_sdi', 'anywhere', 'pack']
  if (device.includes(_type)) {
    if ((status == 0 || status == 3) && thumbnailId.indexOf('0000000000000003') == -1) {
      return require(`@/assets/img/${status == 0 ? 'offlinePng' : 'null'}.png`)
    }
    if (thumbnailId.indexOf('0000000000000003') == -1) {
      if (env == 'cn') {
        return `${header}${cnBlobUrl}/${thumbnailId.toUpperCase()}?type=original&app=cc&${Math.random()}`
      }
      return `${header}${blobUrl}/${thumbnailId.toUpperCase()}?type=original&app=cc&${Math.random()}`
    }
    return ''
  } else {
    return ''
  }
}

// 时间戳格式化时间格式
export const DATE = (date, fmt) => {
  if (!date) {
    return ''
  }
  date = date + ''
  if (date.length > 13) {
    date = date.slice(0, 13)
  }
  date = new Date(date * 1)

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length)
      )
    }
  }
  return fmt
}

// 时间戳格式化时间格式
export const UTCDATE = (date, fmt) => {
  if (!date) {
    return ''
  }
  date = date + ''
  if (date.length > 13) {
    date = date.slice(0, 13)
  }
  date = new Date(date * 1)

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getUTCFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  let o = {
    'M+': date.getUTCMonth() + 1,
    'd+': date.getUTCDate(),
    'h+': date.getUTCHours(),
    'm+': date.getUTCMinutes(),
    's+': date.getUTCSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length)
      )
    }
  }
  return fmt
}

export const FILTERICON = (item) => {
  const { mediaType, subType, ioType } = item
  let _mediaType = mediaType || ''
  let _subType = subType || ''
  _mediaType = _mediaType.toLowerCase()
  _subType = _subType.toLowerCase()
  let type = ''
  if (_mediaType == 'o') {
    type = `${_mediaType}-${_subType}-${ioType}`
  } else if (_mediaType == 'srt' || _mediaType == 'hls') {
    type = `${_mediaType}-${ioType}`
  } else {
    type = _mediaType
  }
  return config.destinationIconByType[type] || 'icon-a-otheroutput2'
}

// 计算持续时间的时间戳为多少天
export const CONVERTDAYS = (startTime, endTime) => {
  if (!startTime || !endTime) return ''
  let result = ''
  let diff = endTime - startTime
  const duration = moment.duration(diff)
  let days = Math.floor(duration.asDays())
  let hours = duration.hours()
  let minutes = duration.minutes()
  let seconds = duration.seconds()
  if (days) result += `${days} days, `
  result += hours < 10 ? `0${hours}:` : `${hours}:`
  result += minutes < 10 ? `0${minutes}:` : `${minutes}:`
  result += seconds < 10 ? `0${seconds}` : seconds
  return result
}
export const FORMATTIME = (value) => {
  if (!value || value < 0) return '00:00:00'
  let totalSeconds = Math.floor(value / 1000)
  let hours = Math.floor(totalSeconds / 3600)
  let minutes = Math.floor((totalSeconds % 3600) / 60)
  let seconds = totalSeconds % 60
  hours = hours > 9 ? hours : '0' + hours
  minutes = minutes > 9 ? minutes : '0' + minutes
  seconds = seconds > 9 ? seconds : '0' + seconds
  return hours + ':' + minutes + ':' + seconds
}

// 首字母大写
export const UPPERCASEFIRSTLETTER = (string) => {
  if (!string) return string
  return string.charAt(0).toUpperCase() + string.slice(1)
}

// 将秒数转换为mm:ss格式
export const FORMATMINSEC = (t) => {
  if (!t || t < 0) return '00:00'
  // 使用moment.js将秒数转换为mm:ss格式
  return moment.utc(t).format('mm:ss')
}

// [Claude Code] MH-3097：把毫秒启动耗时转成口语化全拼文案
// 例：360000 -> "6 minutes"，390000 -> "6 minutes 30 seconds"，45000 -> "45 seconds"，60000 -> "1 minute"
export const FORMATSTARTUPTIME = (t) => {
  if (!t || t < 0) return '0 seconds'
  const totalSec = Math.round(t / 1000)
  const min = Math.floor(totalSec / 60)
  const sec = totalSec % 60
  const parts = []
  if (min > 0) parts.push(`${min} ${min === 1 ? 'minute' : 'minutes'}`)
  if (sec > 0) parts.push(`${sec} ${sec === 1 ? 'second' : 'seconds'}`)
  // min 和 sec 都为 0（不足 1 秒）时兜底
  return parts.length ? parts.join(' ') : '0 seconds'
}

// export const FORMATVIDEO = (val) => {
//   console.info(399, val)
//   if (!val) return ''
//   if (val == 'Unknown') {
//     return '1080p30'
//   } else {
//     return val.replace('2997', '29.97').replace('5994', '59.94')
//   }
// }

export default {
  DATE,
  UTCDATE,
  FORMATTIME,
  FILTERICON,
  CONVERTDAYS,
  UPPERCASEFIRSTLETTER,
  FORMATMINSEC,
  FORMATSTARTUPTIME
  // FORMATVIDEO
}
